export function formatDuration(duration: number) {
  if (duration === 1) {
    return '1 day';
  }

  if (duration > 63) {
    return `${Math.round(duration / 30)} months`;
  }

  if (duration > 14) {
    return `${Math.round(duration / 7)} weeks`;
  }

  return `${duration} days`;
}
